module.exports = __webpack_public_path__ + "static/human-cell-474d24c12cc21c3f19c05cb8b6388610.svg";